module.exports = __webpack_public_path__ + "img/low-fat-chicken-and-dumplings.70f1ef4b.jpg";